import React, { useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Sparkles, ArrowLeft } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export function ForgotPassword() {
  const { t } = useI18n();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || "");
  const [done, setDone] = useState(false);
  const nav = useNavigate();
  async function submit(e) {
    e.preventDefault();
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  }
  return (
    <Shell title={t("Recuperar senha")}>
      {done ? (
        <div className="text-sm text-slate-700">
          {t("Se este e-mail existir, geramos um link de recuperação (verifique os logs do servidor em ambiente de teste).")}
        </div>
      ) : (
        <form onSubmit={submit} data-testid="forgot-form">
          <label className="block text-sm font-medium mb-1">{t("E-mail")}</label>
          <input
            data-testid="forgot-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="cm-input mb-4"
          />
          <button
            type="submit"
            data-testid="forgot-submit"
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg py-2.5"
          >
            {t("Enviar link")}
          </button>
        </form>
      )}
      <button
        onClick={() => nav("/login")}
        data-testid="forgot-back"
        className="mt-6 text-sm text-slate-500 hover:text-slate-900 inline-flex items-center gap-1"
      >
        <ArrowLeft size={14} /> {t("Voltar ao login")}
      </button>
    </Shell>
  );
}

export function ResetPassword() {
  const { t } = useI18n();
  const [sp] = useSearchParams();
  const token = sp.get("token") || "";
  const [pwd, setPwd] = useState("");
  const nav = useNavigate();
  async function submit(e) {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      toast.success(t("Senha alterada"));
      nav("/login");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  }
  return (
    <Shell title={t("Definir nova senha")}>
      <form onSubmit={submit}>
        <label className="block text-sm font-medium mb-1">{t("Nova Senha")}</label>
        <input
          data-testid="reset-password"
          type="password"
          required
          value={pwd}
          onChange={(e) => setPwd(e.target.value)}
          className="cm-input mb-4"
        />
        <button
          type="submit"
          data-testid="reset-submit"
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg py-2.5"
        >
          {t("Alterar senha")}
        </button>
      </form>
    </Shell>
  );
}

function Shell({ title, children }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--cm-bg)]">
      <div className="w-full max-w-md cm-card p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-9 h-9 rounded-xl bg-blue-600 text-white flex items-center justify-center">
            <Sparkles size={18} />
          </div>
          <div className="font-bold text-lg">Clean Manager USA</div>
        </div>
        <h2 className="text-2xl font-bold mb-4">{title}</h2>
        {children}
      </div>
    </div>
  );
}
